module.exports = __webpack_public_path__ + "static/elephant-720-f157377e0da6dfdbfbab259a043a477d.mp4";